import type { ApiResponse } from './types';
import { v3Get } from './axios.instance.V3';

const getAccessToken = (interviewId: number): ApiResponse => v3Get(`interview/video/get/accesstoken/${interviewId}`);
const getRoomHasParticipants = (interviewId: number): ApiResponse =>
  v3Get(`interview/video/participants/${interviewId}`);

export const videoApis = {
  getAccessToken,
  getRoomHasParticipants,
};
